import { render, staticRenderFns } from "./LandPurchase.vue?vue&type=template&id=4faecf0e&"
import script from "./LandPurchase.vue?vue&type=script&lang=js&"
export * from "./LandPurchase.vue?vue&type=script&lang=js&"
import style0 from "./LandPurchase.vue?vue&type=style&index=0&id=4faecf0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports